import React from 'react';
import BaseValidator from 'services/validations/base-validator';
import Const from 'constants';

class PlayersQuantityValidForEachStackItemValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {stacking} = this.dependencies;

        const firstGroupItems = stacking.getFirstGroupItems();
        const firstGroupPlayersQuantity = stacking.getFirstGroupPlayersQuantity();

        this.validatePlayersQuantityInItems(firstGroupItems, firstGroupPlayersQuantity);

        if (this.hasErrors() || !stacking.isDoubleStackModeEnabled()) {
            return;
        }

        const secondGroupItems = stacking.getSecondGroupItems();
        const secondGroupPlayersQuantity = stacking.getSecondGroupPlayersQuantity();

        this.validatePlayersQuantityInItems(secondGroupItems, secondGroupPlayersQuantity);
    }

    private validatePlayersQuantityInItems(items, groupPlayersQuantity): void {
        for (let item of items) {
            const itemPlayersQuantity = this.calcItemPlayersQuantity(item.players);

            if (itemPlayersQuantity > 0 && itemPlayersQuantity < groupPlayersQuantity) {
                this.addError('You did not select enough players in your stacks to generate lineups.');
                break;
            }
        }
    }

    private calcItemPlayersQuantity(players): number {
        let itemPlayersQuantity = 0;
        players.map((player) => {
            if (!player.isExcludedAnywhere()) {
                itemPlayersQuantity++;
            }
        });

        return itemPlayersQuantity;
    }
}

export default PlayersQuantityValidForEachStackItemValidator;
